import { Component, ChangeDetectionStrategy, inject } from '@angular/core';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DialogRef } from '@angular/cdk/dialog';
import { ModalComponent } from '../modal/modal.component';
import { ModalOptions } from '@meplis/common';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from '@meplis/services';
import { SocialService } from '../../../services/application/social.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FaIconNamePipe } from '@cnp/pipes';

interface ExploreFeature {
  icon: string;
  labelKey: string;
}

@Component({
  selector: 'app-explore-meplis-modal',
  standalone: true,
  imports: [TranslatePipe, ModalComponent, FaIconComponent, FaIconNamePipe],
  templateUrl: './explore-meplis-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './explore-meplis-modal.component.scss',
})
export class ExploreMeplisModalComponent {
  private _translateService = inject(TranslateService);
  private _router = inject(Router);
  dialogRef = inject<DialogRef<ExploreMeplisModalComponent>>(DialogRef);
  private _socialService = inject(SocialService);
  data = inject<{
    userInstanceId: string;
}>(MAT_DIALOG_DATA);
  private _toastService = inject(ToastService);

  public modalOptions: ModalOptions;

  public isUnlocking: boolean = false;

  public features: ExploreFeature[] = [
    {
      icon: 'fa-sharp fa-solid fa-layer-group',
      labelKey: 'HUBS.EXPLORE_FEATURES.WORKSPACES',
    },
    {
      icon: 'fa-sharp fa-solid fa-rss',
      labelKey: 'HUBS.EXPLORE_FEATURES.FEED',
    },
    {
      icon: 'fa-sharp fa-solid fa-play',
      labelKey: 'HUBS.EXPLORE_FEATURES.VIDEOS',
    },
    {
      icon: 'fa-sharp fa-solid fa-users',
      labelKey: 'HUBS.EXPLORE_FEATURES.GROUPS',
    },
    {
      icon: 'fa-sharp fa-solid fa-briefcase-medical',
      labelKey: 'HUBS.EXPLORE_FEATURES.CLINICAL_CASES',
    },
    {
      icon: 'fa-sharp fa-solid fa-flask',
      labelKey: 'HUBS.EXPLORE_FEATURES.CLINICAL_TRIALS',
    },
    {
      icon: 'fa-sharp fa-solid fa-ellipsis',
      labelKey: 'HUBS.EXPLORE_FEATURES.AND_MORE',
    },
  ];

  constructor() {
    this.modalOptions = {
      title: this._translateService.instant('HUBS.EXPLORE_MEPLIS'),
      closeable: true,
      showNegativeButton: true,
      negativeButtonLabel: this._translateService.instant('CANCEL'),
      showPositiveButton: true,
      positiveButtonLabel: this._translateService.instant(
        'HUBS.EXPLORE_MEPLIS_UNLOCK'
      ),
    };
  }

  public close(): void {
    this.dialogRef.close();
  }

  public unlock(): void {
    this.isUnlocking = true;

    this._socialService
      .unlockGlobalFeatures(this.data.userInstanceId)
      .subscribe({
        next: () => {
          this.isUnlocking = true;
          this.dialogRef.close();
          this._router.navigate(['/feed']);
        },
        error: (error) => {
          this._toastService.showError(error);
        },
      });
  }
}
